// Konvertiert geteilte Drive/YouTube/Vimeo Links in Embed-URLs
export function toEmbedUrl(rawUrl) {
  if (!rawUrl) return null;
  const url = rawUrl.trim();

  // Google Drive: https://drive.google.com/file/d/FILE_ID/view?usp=sharing
  const driveMatch = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (driveMatch) {
    return { type: "iframe", src: `https://drive.google.com/file/d/${driveMatch[1]}/preview`, external: url };
  }
  // Drive open?id=...
  const driveOpen = url.match(/drive\.google\.com\/open\?id=([a-zA-Z0-9_-]+)/);
  if (driveOpen) {
    return { type: "iframe", src: `https://drive.google.com/file/d/${driveOpen[1]}/preview`, external: url };
  }

  // YouTube: youtu.be/ID  or  youtube.com/watch?v=ID
  const ytShort = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
  const ytLong = url.match(/[?&]v=([a-zA-Z0-9_-]+)/);
  const ytEmbed = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
  const ytId = (ytShort && ytShort[1]) || (ytLong && ytLong[1]) || (ytEmbed && ytEmbed[1]);
  if (ytId && /youtube|youtu\.be/.test(url)) {
    return { type: "iframe", src: `https://www.youtube.com/embed/${ytId}`, external: url };
  }

  // Vimeo: vimeo.com/ID
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return { type: "iframe", src: `https://player.vimeo.com/video/${vimeo[1]}`, external: url };
  }

  // Direct mp4/webm
  if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) {
    return { type: "video", src: url, external: url };
  }

  // Fallback: einfacher Link
  return { type: "link", external: url };
}
